import { PlanningBalancesByPeriodsQuery } from 'generated/resources/graphql'

type TimePlanningBalancesByPeriod = NonNullable<
  PlanningBalancesByPeriodsQuery['timePlanning']['balancesByPeriodsConnection']['nodes']
>[number]
import moment from 'moment'

import { ShiftsRow } from 'modules/shift_management/lib/types'
import type PlannedBreaks from 'modules/time_planning/store/internal/collections/plannedBreaks'

const overPlannedHoursCalculator = (
  shiftsRow: ShiftsRow,
  periodBalances: TimePlanningBalancesByPeriod[],
  plannedBreaksCollection: PlannedBreaks,
  maximumWeeklyHoursInCents?: number
) => {
  if (!maximumWeeklyHoursInCents)
    return {
      overPlannedPeriods: [],
      maximumWeeklyHours: 0,
    }

  // We get the maximum weekly hours in cents, so we need to divide by 100 to get the hours,
  // then convert to milliseconds, since duration is in milliseconds
  const maximumWeeklyHours = maximumWeeklyHoursInCents / 100
  const maximumWeeklyHoursInMilliseconds = (maximumWeeklyHours || 0) * 60 * 60 * 1000

  const durations = periodBalances.map((period) => {
    const duration = shiftsRow.hoursPerRangeAsMilliseconds(
      moment(period.startAt).clone().startOf('day'),
      moment(period.endAt).clone().endOf('day'),
      plannedBreaksCollection
    )

    const leaveHoursInMilliseconds = (period.leaveHours ?? 0) * 60 * 60 * 1000
    const bankHolidayHoursInMilliseconds = (period.bankHolidayHours ?? 0) * 60 * 60 * 1000

    const maxPeriodDuration =
      maximumWeeklyHoursInMilliseconds - leaveHoursInMilliseconds - bankHolidayHoursInMilliseconds

    return {
      ...period,
      week: moment(period.startAt).clone().week(),
      isOverMaximum: duration > maxPeriodDuration,
    }
  })

  return {
    overPlannedPeriods: durations.filter((duration) => duration.isOverMaximum),
    maximumWeeklyHours,
  }
}

export default overPlannedHoursCalculator
